// Poster sizes in inches (portrait base). Orientation handled by swapping.
export const posterSizes = [
  { id: 'letter', name: 'Letter', w: 8.5, h: 11 },
  { id: 'tabloid', name: 'Tabloid 11\u00d717', w: 11, h: 17 },
  { id: '16x20', name: '16\u00d720', w: 16, h: 20 },
  { id: '18x24', name: '18\u00d724', w: 18, h: 24 },
  { id: '20x30', name: '20\u00d730', w: 20, h: 30 },
  { id: '24x36', name: '24\u00d736', w: 24, h: 36 },
  { id: 'a3', name: 'A3', w: 11.69, h: 16.54 },
  { id: 'a2', name: 'A2', w: 16.54, h: 23.39 },
];

export function getSize(id) {
  return posterSizes.find((s) => s.id === id) || posterSizes[3];
}
